export const en = {
  homePage: {
    helloWorld: 'Hi, how you doin?',
    countable: 'no count | one count | 2nd thing | {count} thingy',
    variablesOne: 'First var: {0}, Second var: {1}'
  },
  'homePage.variablesTwo': 'First var: {one}, Second var: {two}',
  nav: {
    model: 'Models',
    details: 'Details',
    summary: 'Summary',
    preview: 'Checkout',
  },
  footer:{
    total: 'Total: {price} (without VAT)',
    next: 'Next',
    submit: 'Proceed to payment',
    finish: 'Submit inquiry',
    back: 'Back'
  },
  model: {
    selectModel: 'Select a model'
  },
  details: {
    editItem: 'Design your chair',
    tooltip: `Selected material is available on request only. We invite you to view the samples at: <a href="https://vez-sedezi.si/en/options/" target="#" class="underline">https://vez-sedezi.si/en/options/</a> and contact us, so we can choose the best option for you, together.`,
    tooltipOk: 'OK',
    noBackrestUpholstery: 'No backrest upholstery',
    backrest: 'Backrest',
    upholstered: 'Upholstered',
    notUpholstered: 'Not upholstered',
    options: 'no options | 1 option | {options} options',
    loadingModel: 'Loading model...',
    colorWarning: 'Color patterns on your computer may deviate from the actual situation.'
  },
  maps: {
    bugy: {
      legs: 'Legs',
      seat: 'Seat',
      seatingAndBackrest: 'Upholstery'
    },
    barly: {
      legs: 'Legs',
      seat: 'Seat',
      seatingAndBackrest: 'Upholstery'
    },
    barman: {
      seat: 'Seat',
      seatingAndBackrest: 'Upholstery'
    },
    kuki: {
      legs: 'Legs',
      seat: 'Seat',
      seatingAndBackrest: 'Upholstery'
    },
    praktik: {
      seat: 'Seat',
      seatingAndBackrest: 'Upholstery'
    },
    scorpio: {
      legs: 'Legs',
      seat: 'Seat',
      seatingAndBackrest: 'Upholstery',
      legsShape: 'Leg shape'
    }
  },
  summary: {
    summary: 'Summary',
    send_inquiry: 'Send inquiry',
    message: 'Ordering a single chair is possible. If your wishes are different, the price of the chair changes based on material selection and quantity. Please type your wishes in the comment box.',
    remove: 'Remove',
    edit: 'Edit',
    duplicate: 'Duplicate',
    addNewProduct: 'Add new product',
    card: {
      pricePerItem: '{price} / item (without VAT)'
    }
  },
  preview: {
    summary: 'Checkout',
    vatBasis: 'VAT basis',
    vat: 'VAT',
    totalPrice: 'Total price',
    yourInfo: 'Your info',
    delivery: 'Delivery',
    freeDelivery: 'By agreement.',
    payment: 'Payment',
    price: {
      free: 'Free',
      formatted: '{price}'
    },
  },
  done: {
    thankYou: 'Thank you!',
    done1: 'We have received your request.',
    done2: 'Want to learn more about personalized chairs?',
    done3: 'We suggest you read more on our website.',
    back: 'Back to homepage'
  },
  inputs: {
    comment: 'Comments',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone number',
    mail: 'Email',
    address: 'Address',
    post: 'Postal code',
    city: 'City',
    businessReceipt: 'Business receipt',
    taxId: 'Tax ID',
    company: 'Company name'
  },
  errors: {
    firstName: 'First name is required',
    firstNameLength: 'First name should have length of {length}',
    lastName: 'Last name is required',
    lastNameLength: 'Last name should have length of {length}',
    phone: 'Phone number is required',
    phoneValid: 'Phone number not valid',
    mail: 'Email is required',
    mailValid: 'Email not valid',
    address: 'Address is required',
    post: 'Postal code is required',
    city: 'City is required',
    taxId: 'Tax ID is required',
    company: 'Company name is mandatory',
    delivery: 'Delivery is required'
  },
  payment:{
    later: 'Just send inquiry',
    now: 'I wish to pay now'
  }

};

export const currencyEnUS = {
  currency: {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'symbol'
  }
}
